import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { toastError, toastSuccess } from '@components/Toast';

import AddColors from '@features/zalandoPOUpload/components/AddColors';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

const UploadZalandoPO = ({ show, handleClose, brandId }) => {
	const dispatch = useDispatch();
	const { id } = useParams();
	const [title, setTitle] = useState('');
	const [orderBuyer, setOrderBuyer] = useState('');
	const [fileResponse, setFileResponse] = useState([]);
	const [allItems, setAllItems] = useState([]);
	const [fileName, setFileName] = useState([]);
	const [, setSearchBuyerLoading] = useState(false);
	const [showBuyerSuggestion, setShowBuyerSuggestion] = useState(false);
	const [buyerList, setBuyerList] = useState([]);
	const [buyerId, setBuyerId] = useState('');
	const [selectedProduct, setSelectedProduct] = useState(null);
	const BuyerEmailRef = useRef(null);
	const resultsRef = useRef();
	const inputRef = useRef();
	const navigate = useNavigate();
	const [errors, setErrors] = useState({});

	const clearStates = () => {
		setFileName([]);
		setTitle('');
		setOrderBuyer('');
		setErrors({});
		setSelectedProduct(null);
		setAllItems([]);
		setFileResponse([]);
	};

	const clearModal = () => {
		clearStates();
		handleClose();
	};

	const handleFile = (e) => {
		e.preventDefault();
		clearStates();
		dispatch(openLoader());
		let fileNames = [];
		Array.from(e.target.files).forEach((item) => fileNames.push(item.name));
		setFileName(fileNames);
		ApiClient.UPLOAD_MULTIPLE_FILE(
			'extractFile',
			Array.from(e.target.files),
			`?collectionId=${id}`,
			'json'
		)
			.then(async (res) => {
				let uniqueData = [];
				let filteredData = [];
				setAllItems([...res.data]);
				await res.data.forEach((item) => {
					if (!uniqueData.includes(item.colorCode)) {
						uniqueData.push(item.colorCode);
						filteredData.push(item);
					}
				});
				setFileResponse(filteredData);
				dispatch(closeLoader());
			})
			.catch((error) => {
				toastError(error.response.data.message);
				dispatch(closeLoader());
			});
	};

	const onAddNewColors = (payload) => {
		let cloneFileResponse = [...fileResponse];
		cloneFileResponse.forEach((item) => {
			if (item.colorCode === selectedProduct) {
				item.colorId = payload.id;
			}
		});
		setFileResponse(cloneFileResponse);
		let clonedAllItems = [...allItems];
		clonedAllItems.forEach((item) => {
			if (item.colorCode === selectedProduct) {
				item.colorId = payload.id;
			}
		});
		setAllItems(clonedAllItems);
	};

	const onRemoveColors = (colorId, colorCode) => {
		let cloneFileResponse = [...fileResponse];
		cloneFileResponse.forEach((item) => {
			if (item.colorCode === colorCode && item?.colorId === colorId) {
				item.colorId = null;
			}
		});
		setFileResponse(cloneFileResponse);
		let clonedAllItems = [...allItems];
		clonedAllItems.forEach((item) => {
			if (item.colorCode === colorCode && item?.colorId === colorId) {
				item.colorId = null;
			}
		});
		setAllItems(clonedAllItems);
	};

	const renderAddColor = (selectedColors, productId, colorCode) => {
		return (
			<AddColors
				productId={productId}
				colorCode={colorCode}
				tagColor={onAddNewColors}
				onRemoveColors={onRemoveColors}
				isShowRFD={false}
			/>
		);
	};

	const renderCodes = () => {
		if (fileResponse.length > 0) {
			return fileResponse.map((item, index) => {
				return (
					<tr key={`codes_${item?.colorCode}_${index}`}>
						<td>{item?.styleCode}</td>
						<td>{item?.colorCode}</td>
						<td onClick={() => setSelectedProduct(item.colorCode)}>
							{renderAddColor(undefined, item.productId, item.colorCode)}
						</td>
					</tr>
				);
			});
		}
	};

	const getBuyerSuggestions = async (value) => {
		setSearchBuyerLoading(true);
		let params = `?organizationType=BUYER&email=${value}&brandId=${brandId}`;
		await ApiClient.GET('getUserSuggestions', params)
			.then(({ data }) => {
				setSearchBuyerLoading(false);
				if (data) {
					setBuyerList(data);
				}
			})
			.catch(({ response }) => {
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const setBuyer = (user) => {
		setOrderBuyer(user.email);
		setBuyerId(user.id);
		setShowBuyerSuggestion(false);
	};

	const onChangeOrder = async (e) => {
		inputRef.current.focus();
		let { name, value } = e.target;
		if (name === 'orderBuyer') {
			setOrderBuyer(value);
			getBuyerSuggestions(value);
		}
	};

	const checkValidation = async () => {
		let errorObj = {};
		if (!title) {
			errorObj['title'] = 'Title required';
		}
		if (!buyerId) {
			errorObj['buyer'] = 'Buyer required';
		}
		setErrors(errorObj);
		return Object.keys(errorObj).length > 0;
	};

	const handleSubmit = async () => {
		let isInvalid = await checkValidation();
		if (!isInvalid) {
			dispatch(openLoader());
			let postData = {
				buyerId: buyerId,
				collectionId: id,
				poItems: allItems,
				title: title
			};
			await ApiClient.POST('submitExtract', postData)
				.then(({ data }) => {
					dispatch(closeLoader());
					toastSuccess('Submit Successful!');
					clearModal();
					navigate('/orders/view/' + data.payload);
				})
				.catch(({ response }) => {
					dispatch(closeLoader());
					toastError(response.data.message);
				});
		}
	};

	const renderFileNames = () => {
		return fileName?.map((name, index) => (
			<p
				key={`file_${index}`}
				className="chip-square-gray cursor-pointer regular-14 gray_dark_01 d-inline-block mb-0"
				title={name}
			>
				{name}
			</p>
		));
	};

	return (
		<Modal show={show} centered={true}>
			<div className="popup-wrapper">
				<div className="common-popup zalando-po-upload-modal shadow-24dp">
					<div className="common-popup-header d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">Zalando PO upload</h3>
						</div>
						<div className="close-btn" onClick={clearModal}>
							<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
						</div>
					</div>
					<div className="common-popup-body scroll-y-label">
						<div className="row">
							<div className="col-md-6">
								<div className="form-group">
									<label htmlFor="oder-title">Order title</label>
									<input
										type="text"
										autoComplete="off"
										id="oder-title"
										name="title"
										value={title}
										onChange={(e) => {
											setTitle(e.target.value);
										}}
									/>
									{errors.title && <span className="error">{errors.title}</span>}
								</div>
							</div>
							<div className="col-md-6">
								<div className="form-group">
									<label>Buyer</label>
									<input
										ref={inputRef}
										className={'bg-gray-light border-0'}
										type="text"
										placeholder="Search with buyer E-mail"
										value={orderBuyer}
										name="orderBuyer"
										onFocus={onChangeOrder}
										onChange={onChangeOrder}
										onClick={() => setShowBuyerSuggestion(true)}
										autoComplete="off"
									/>
									{showBuyerSuggestion ? (
										<div className="suggest-filed scroll-y-label" ref={BuyerEmailRef}>
											<ul ref={resultsRef}>
												{buyerList.length ? (
													buyerList.map((item) => (
														<li
															key={item.id}
															onClick={() => setBuyer(item)}
															tabIndex={0}
															onKeyPress={(e) => {
																if (e.key === 'Enter') {
																	setBuyer(item);
																}
															}}
														>
															{item.email}
														</li>
													))
												) : (
													<li onClick={() => setShowBuyerSuggestion(false)}>
														No suggestions found
													</li>
												)}
											</ul>
										</div>
									) : (
										<></>
									)}
									{errors.buyer && <span className="error">{errors.buyer}</span>}
								</div>
							</div>
						</div>
						<div className="upload-pi-invoices d-flex align-items-center mt-1 ">
							<div className="upload-pi">
								<label
									htmlFor="zalando-po"
									className="drag-upload cursor-pointer d-flex mb-0 mr-2 pr-1"
								>
									<img
										src={`${process.env.PUBLIC_URL}/icons/upload-dark.svg`}
										alt="upload"
										className="upload-icon"
										style={{ width: '18px' }}
									/>
									<p className="regular-14 gray_dark_01 ml-1">Upload PO</p>
								</label>
								<input
									id="zalando-po"
									type="file"
									onChange={handleFile}
									multiple
									onClick={(e) => (e.target.value = null)}
									className="file-upload d-none"
								/>
							</div>
							<div className="uploaded-pi">
								{fileName.length > 0 && (
									<div className="d-flex flex-wrap gap-1">{renderFileNames()}</div>
								)}
							</div>
						</div>

						<table className="mt-3 table table-bordered no-hover">
							<tr>
								<th>Style no</th>
								<th>Color Code</th>
								<th>Action</th>
							</tr>
							{renderCodes()}
						</table>
					</div>
					<div className="common-popup-footer d-flex justify-content-end pb-3 px-4">
						<button type={'submit'} className="button size32" onClick={handleSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default UploadZalandoPO;
